import React from 'react';

const PricingImage = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 712.357 800" role="img">
    <g transform="translate(-754.92 -94.487)">
      <g transform="translate(979.759 271.362)">
        <path
          d="M535.569,109.948s5.085,29.491,2.034,35.593,24.406,18.3,24.406,18.3l14.237-34.576V109.948Z"
          transform="translate(-472.519 -52.485)"
          fill="#ed9da0"
        />
        <path
          d="M460.749,439.851s-11.186,51.864,4.068,50.847,8.135-47.8,8.135-47.8Z"
          transform="translate(-451.159 -122.89)"
          fill="#ed9da0"
        />
        <path
          d="M488.986,716l7.118,37.626,16.271-2.034-5.085-40.678Z"
          transform="translate(-422.885 -152.104)"
          fill="#ed9da0"
        />
        <path
          d="M593.779,670.811l4.068,27.457H619.2l-4.068-25.423Z"
          transform="translate(-445.306 -143.523)"
          fill="#ed9da0"
        />
        <path
          d="M515.35,403.632s-17.288,33.559-11.186,116.948,21.349,164.958,21.349,164.958l28.481-5.3,12.2-207.455,47.8,180,28.763,6.123-5.373-185.1L611.959,389.4Z"
          transform="translate(-465.52 -112.274)"
          fill="#2f2e41"
        />
        <path
          d="M542.744,777.613s3.051-9.152-2.034-9.152H529.523s-12.2,22.372-19.322,24.406-29.491,21.356-8.135,23.39,53.9-9.153,53.9-13.22-3.051-21.356-3.051-21.356Z"
          transform="translate(-463.423 -193.377)"
          fill="#2f2e41"
        />
        <path
          d="M664.138,733.989s-18.694-5.171-17.483-2.077-2.856,12.246-2.856,12.246-10.169,57.965,20.339,52.881,8.136-48.813,8.136-48.813l-4.517-17.3Z"
          transform="translate(-495.327 -185.346)"
          fill="#2f2e41"
        />
        <circle
          cx="30.508"
          cy="30.508"
          r="30.508"
          transform="translate(52.881 10.685)"
          fill="#ed9da0"
        />
        <path
          d="M547.134,148.4s-9.257,1.362-13.273-5.421-13.168,47.115-13.168,47.115,4.068,71.185-1.017,87.456-4.068,22.373-2.034,25.423,8.135-1.017,3.051,7.119-5.085,3.051-5.085,11.186-2.034,37.627-2.034,37.627L623.4,350.769,571.54,128.06S554.253,149.416,547.134,148.4Z"
          transform="translate(-467.813 -56.36)"
          fill="#f2f2f2"
        />
        <path
          d="M595.53,136.276s35.433,4.481,37.162,11.2,36.3,193.446,18.149,203.156-76.916,17.179-79.509,7.469-16.42-207.637,8.642-230.044Z"
          transform="translate(-478.857 -50.667)"
          fill="#2f2e41"
        />
        <path
          d="M584.085,646.648a3.091,3.091,0,0,1-1.482-.828C584.245,646.481,584.936,646.827,584.085,646.648Z"
          transform="translate(-482.582 -167.137)"
          fill="#2f2e41"
        />
        <path
          d="M527.782,144.232l-39.6,28.309,14.237,91.914s-28.474,108.826-12.2,108.826,14.237,1.471,17.288-6.618S527.782,144.232,527.782,144.232Z"
          transform="translate(-461.741 -52.373)"
          fill="#2f2e41"
        />
        <path
          d="M493.13,190.16l-10.492,3.067s-9.443,7.157-8.394,22.492-1.049,59.3-1.049,59.3-6.3,9.2-3.148,20.447l-14.689,98.146,32.527,5.112L499.425,347.6Z"
          transform="translate(-455.357 -69.646)"
          fill="#2f2e41"
        />
        <path
          d="M660.879,395.6s-12.2,55.929,0,52.378,27.457-42.612,17.288-48.827S660.879,395.6,660.879,395.6Z"
          transform="translate(-498.169 -113.481)"
          fill="#ed9da0"
        />
        <path
          d="M521.943,81.614s-3.115-4.672-1.917-9.7a29.407,29.407,0,0,0,.839-8.745s2.516-8.146,5.031-12.7,1.318-6.469,9.224-7.906,4.672-11.74,25.516-.6a6.113,6.113,0,0,0,6.349,2.4c4.313-.839,5.87,5.151,5.87,5.151s2.875-1.677,3.953.719,8.766-1.438,8.766,14.734-8.748,30.618-8.748,30.618.641-27.2-13.614-29.959-29.589-10.781-33.3-.479a78.531,78.531,0,0,1-7.966,16.472Z"
          transform="translate(-469.135 -36.844)"
          fill="#2f2e41"
        />
        <path
          d="M642.3,153.886s23.39-4.068,28.474,26.44,18.3,90.507,18.3,90.507l-3.631,91.549-34-11.211L652.474,281,635.186,176.259Z"
          transform="translate(-493.832 -61.847)"
          fill="#2f2e41"
        />
        <path
          d="M582.782,169.488,596,255.928l-3.05,73.219,14.237-71.186Z"
          transform="translate(-442.953 -36.263)"
          opacity="0.15"
        />
      </g>
      <g transform="translate(1242.984 220.595)">
        <g transform="translate(0 0)">
          <path
            d="M229.849,173.658,192.79,145.9l-36.553,27.378-.837-1.116,37.39-28.006,36.883,27.626,36.651-40.109.147-.06,36.971-14.9.522,1.294L267.14,132.849Z"
            transform="translate(-117.634 -112.965)"
            fill="#d6d6e3"
          />
          <path
            d="M543.328,446.077H320.43a.7.7,0,0,1-.7-.7V338.545a.7.7,0,0,1,1.4,0V444.682h222.2a.7.7,0,0,1,0,1.4Z"
            transform="translate(-319.732 -334.005)"
            fill="#3f3d56"
          />
          <path
            d="M379.316,468.088H359.042a2.073,2.073,0,0,1-2.071-2.07V438.07a2.073,2.073,0,0,1,2.071-2.07h20.273a2.073,2.073,0,0,1,2.071,2.07v27.948A2.073,2.073,0,0,1,379.316,468.088Z"
            transform="translate(-330.994 -363.689)"
            fill="#406048"
          />
          <path
            d="M432.316,456.6H412.042a2.073,2.073,0,0,1-2.071-2.07V400.07a2.073,2.073,0,0,1,2.071-2.07h20.273a2.073,2.073,0,0,1,2.071,2.07v54.455a2.073,2.073,0,0,1-2.071,2.07Z"
            transform="translate(-347.022 -352.197)"
            fill="#406048"
          />
          <path
            d="M485.316,468.088H465.042a2.073,2.073,0,0,1-2.071-2.07V438.07a2.073,2.073,0,0,1,2.071-2.07h20.273a2.073,2.073,0,0,1,2.071,2.07v27.948A2.073,2.073,0,0,1,485.316,468.088Z"
            transform="translate(-363.051 -363.689)"
            fill="#406048"
          />
          <path
            d="M538.315,452.059H518.042a2.028,2.028,0,0,1-2.071-1.977V384.976A2.028,2.028,0,0,1,518.042,383h20.273a2.028,2.028,0,0,1,2.071,1.977v65.106A2.028,2.028,0,0,1,538.315,452.059Z"
            transform="translate(-379.08 -347.66)"
            fill="#406048"
          />
          <path
            d="M591.316,443.894H571.042a2.073,2.073,0,0,1-2.071-2.07V358.07a2.073,2.073,0,0,1,2.071-2.07h20.273a2.073,2.073,0,0,1,2.071,2.07v83.753a2.073,2.073,0,0,1-2.071,2.07Z"
            transform="translate(-395.109 -339.495)"
            fill="#406048"
          />
          <ellipse
            cx="4.285"
            cy="4.017"
            rx="4.285"
            ry="4.017"
            transform="translate(33.812 55.706)"
            fill="#3f3d56"
          />
          <circle
            cx="4.285"
            cy="4.285"
            r="4.285"
            transform="translate(70.771 28.389)"
            fill="#3f3d56"
          />
          <ellipse
            cx="4.285"
            cy="4.017"
            rx="4.285"
            ry="4.017"
            transform="translate(107.729 55.706)"
            fill="#3f3d56"
          />
          <circle
            cx="4.285"
            cy="4.285"
            r="4.285"
            transform="translate(144.688 14.998)"
            fill="#3f3d56"
          />
          <ellipse
            cx="4.285"
            cy="4.286"
            rx="4.285"
            ry="4.286"
            transform="translate(181.646)"
            fill="#3f3d56"
          />
        </g>
      </g>
      <g transform="translate(754.92 293.401)">
        <path
          d="M388.805,456.6H311.429a6.854,6.854,0,0,0-6.854,6.854v37.7a6.854,6.854,0,0,0,6.854,6.854h77.376a6.854,6.854,0,0,0,6.854-6.854v-37.7A6.854,6.854,0,0,0,388.8,456.6Zm-79.291,4.676a9.459,9.459,0,0,1,10.976,6.6l.121.377-.39.069a10.344,10.344,0,0,1-1.679.123,10,10,0,0,1-5.1-1.285,10.824,10.824,0,0,1-4.2-5.443l-.121-.376Zm16.8,35h-13.8a3.8,3.8,0,0,1,0-7.591h13.8a3.8,3.8,0,0,1,0,7.591Zm62.793-.69a4.152,4.152,0,0,1-4.14,4.14h-10.35a4.153,4.153,0,0,1-4.14-4.14v-6.21a4.153,4.153,0,0,1,4.14-4.14h10.351a4.152,4.152,0,0,1,4.14,4.14Z"
          transform="translate(-304.575 -456.6)"
          fill="#406048"
        />
        <path
          d="M498.771,561.213h-4.161a1.121,1.121,0,1,0,0,2.241h4.162a1.121,1.121,0,0,0,0-2.241Z"
          transform="translate(-425.396 -523.505)"
          fill="#3f3d56"
        />
        <path
          d="M520.086,561.213h-4.162a1.121,1.121,0,1,0,0,2.241h4.162a1.121,1.121,0,0,0,0-2.241Z"
          transform="translate(-439.027 -523.505)"
          fill="#3f3d56"
        />
        <path
          d="M498.771,552.438h-4.16a1.121,1.121,0,1,0,0,2.241h4.162a1.121,1.121,0,0,0,0-2.241Z"
          transform="translate(-425.395 -517.894)"
          fill="#3f3d56"
        />
        <path
          d="M520.084,552.438h-4.162a1.121,1.121,0,0,0,0,2.241h4.162a1.121,1.121,0,1,0,0-2.241Z"
          transform="translate(-439.027 -517.894)"
          fill="#3f3d56"
        />
        <path
          d="M498.771,543.841h-4.16a1.121,1.121,0,1,0,0,2.241h4.162a1.121,1.121,0,1,0,0-2.241Z"
          transform="translate(-425.395 -512.395)"
          fill="#3f3d56"
        />
        <path
          d="M520.084,543.841h-4.162a1.121,1.121,0,0,0,0,2.241h4.162a1.121,1.121,0,1,0,0-2.241Z"
          transform="translate(-439.027 -512.395)"
          fill="#3f3d56"
        />
      </g>
      <g transform="translate(1165.092 140.699)">
        <path
          d="M538.3,233.42a26.523,26.523,0,0,0-26.5,25.7c-.008.269-.011.542-.011.814A26.511,26.511,0,1,0,538.3,233.42Zm0,52.264a25.78,25.78,0,0,1-25.753-25.754q0-.528.023-1.045a25.753,25.753,0,1,1,25.731,26.8Z"
          transform="translate(-511.79 -233.42)"
          fill="#3f3d56"
        />
        <path
          d="M567.48,266.764a22.345,22.345,0,1,1-44.69,0c0-.708.034-1.405.1-2.094a22.345,22.345,0,0,1,44.591,2.094Z"
          transform="translate(-518.624 -240.253)"
          fill="#e6e6e6"
        />
        <path
          d="M576.143,283.2a5.321,5.321,0,0,0-2.072-1.64,20.123,20.123,0,0,0-3.113-1.023v-6.082a8.86,8.86,0,0,1,4.427,2.019l1.235-2.632a8.166,8.166,0,0,0-2.409-1.488,11.838,11.838,0,0,0-3.056-.784V268.49H568.3V271.6a7.829,7.829,0,0,0-3.125,1.049,6.211,6.211,0,0,0-2.117,2.076,5.214,5.214,0,0,0-.754,2.761,4.72,4.72,0,0,0,.867,2.954,5.5,5.5,0,0,0,2.159,1.712,19.944,19.944,0,0,0,3.166,1.049v5.829a9.464,9.464,0,0,1-5.268-2.1l-1.235,2.636a9.31,9.31,0,0,0,2.818,1.6,12.938,12.938,0,0,0,3.488.727v3.056h2.859v-3.113a7.4,7.4,0,0,0,4.245-1.947,5.147,5.147,0,0,0,1.583-3.825A4.566,4.566,0,0,0,576.143,283.2Zm-7.65-3.306a5.49,5.49,0,0,1-1.905-1.023,2.015,2.015,0,0,1-.674-1.583,2.547,2.547,0,0,1,.689-1.822,3.485,3.485,0,0,1,1.89-.981Zm4.261,8.059a3.241,3.241,0,0,1-1.8.935v-5.014a5.015,5.015,0,0,1,1.8.9,1.764,1.764,0,0,1,.617,1.4,2.577,2.577,0,0,1-.617,1.78Z"
          transform="translate(-542.978 -255.208)"
          fill="#406048"
        />
      </g>
      <g transform="translate(809.825 157.541)">
        <g transform="translate(0 0)">
          <path
            d="M536.36,566.058q1.09-.056,2.193-.058a41.661,41.661,0,0,1,41.661,41.661H536.36Z"
            transform="translate(-489.216 -566)"
            fill="#406048"
          />
          <path
            d="M588.119,662.51a42.806,42.806,0,0,0,42.758-42.758,1.1,1.1,0,0,0-1.1-1.1H587.022V578.149a1.094,1.094,0,0,0-.342-.795,1.073,1.073,0,0,0-.811-.3,42.757,42.757,0,0,0,2.249,85.456Zm40.55-41.661A40.565,40.565,0,1,1,584.83,579.32v40.433a1.1,1.1,0,0,0,1.1,1.1Z"
            transform="translate(-545.36 -572.609)"
            fill="#3f3d56"
          />
        </g>
        <path
          d="M345.356,114.309a8.252,8.252,0,0,1,0-8.912,4.507,4.507,0,0,1,3.617-1.526,4.582,4.582,0,0,1,3.658,1.526,8.181,8.181,0,0,1,0,8.912,4.581,4.581,0,0,1-3.658,1.527A4.507,4.507,0,0,1,345.356,114.309Zm5.185-1.582a6.222,6.222,0,0,0,.495-2.888,6.011,6.011,0,0,0-.509-2.847,1.673,1.673,0,0,0-1.554-.894,1.621,1.621,0,0,0-1.513.894,6.156,6.156,0,0,0-.495,2.847,6.234,6.234,0,0,0,.495,2.874,1.62,1.62,0,0,0,1.513.894A1.669,1.669,0,0,0,350.541,112.728Zm-.245,8.384,9.817-16.966h0a1.759,1.759,0,0,1,1.521,2.641l-9.828,16.944h0a1.745,1.745,0,0,1-1.51-2.619ZM359.3,122.4A6.749,6.749,0,0,1,358,117.9a6.6,6.6,0,0,1,1.307-4.428,5.147,5.147,0,0,1,7.289,0,8.275,8.275,0,0,1,0,8.926,5.114,5.114,0,0,1-7.289,0Zm5.185-1.6a6.233,6.233,0,0,0,.5-2.874,6.015,6.015,0,0,0-.509-2.847,1.762,1.762,0,0,0-3.067,0,6.153,6.153,0,0,0-.5,2.847,6.231,6.231,0,0,0,.5,2.874,1.774,1.774,0,0,0,3.081,0Z"
          transform="translate(-327.939 -54.611)"
        />
      </g>
      <g transform="translate(968.796 94.487)">
        <path
          d="M302.111,250.777A1.6,1.6,0,0,0,301,252.745L327.7,348.1a1.6,1.6,0,0,0,1.969,1.107L428.1,321.645a1.6,1.6,0,0,0,1.107-1.969l-26.7-95.354a1.6,1.6,0,0,0-1.969-1.107Z"
          transform="translate(-300.944 -223.156)"
          fill="#e6e6e6"
        />
        <path
          d="M339.454,353.25l93.8-26.264-25.4-90.722-93.8,26.264Z"
          transform="translate(-309.49 -231.702)"
          fill="#fff"
        />
        <path
          d="M348.362,324.048c-.626.175-.884,1.215-.575,2.317s1.069,1.857,1.695,1.682l42.78-11.979c.626-.175.884-1.215.575-2.317s-1.069-1.857-1.695-1.682Z"
          transform="translate(-331.399 -281.108)"
          fill="#e6e6e6"
        />
        <path
          d="M358.261,359.4c-.626.175-.884,1.215-.575,2.317s1.069,1.857,1.695,1.682l42.779-11.979c.626-.175.884-1.215.575-2.317s-1.069-1.857-1.695-1.682Z"
          transform="translate(-337.853 -304.156)"
          fill="#e6e6e6"
        />
        <path
          d="M368.045,394.344c-.626.175-.884,1.215-.575,2.317s1.069,1.857,1.695,1.682l42.779-11.979c.626-.175.884-1.215.575-2.317s-1.069-1.857-1.695-1.682Z"
          transform="translate(-344.232 -326.938)"
          fill="#e6e6e6"
        />
        <path
          d="M377.944,429.7c-.626.175-.884,1.215-.575,2.317s1.069,1.857,1.695,1.682l42.779-11.979c.626-.175.884-1.215.575-2.317s-1.069-1.857-1.695-1.682Z"
          transform="translate(-350.686 -349.987)"
          fill="#e6e6e6"
        />
        <path
          d="M532.138,290.717a2.076,2.076,0,1,0,1.12,4l8-2.239a2.076,2.076,0,0,0-1.12-4Z"
          transform="translate(-450.685 -265.693)"
          fill="#e6e6e6"
        />
        <path
          d="M541.845,325.384a2.076,2.076,0,1,0,1.12,4l8-2.239a2.076,2.076,0,1,0-1.12-4Z"
          transform="translate(-457.014 -288.295)"
          fill="#e6e6e6"
        />
        <path
          d="M551.552,360.051a2.076,2.076,0,0,0,1.12,4l8-2.239a2.076,2.076,0,1,0-1.12-4Z"
          transform="translate(-463.343 -310.896)"
          fill="#e6e6e6"
        />
        <path
          d="M561.259,394.717a2.076,2.076,0,0,0,1.12,4l8-2.239a2.076,2.076,0,0,0-1.12-4Z"
          transform="translate(-469.671 -333.498)"
          fill="#e6e6e6"
        />
        <path
          d="M569.754,453.616a2.646,2.646,0,1,0,1.427,5.1l10.19-2.853a2.646,2.646,0,0,0-1.427-5.1h0Z"
          transform="translate(-474.938 -371.483)"
          fill="#406048"
        />
        <rect
          width="78.308"
          height="0.696"
          transform="matrix(0.963, -0.27, 0.27, 0.963, 29.896, 92.957)"
          fill="#e6e6e6"
        />
      </g>
    </g>
  </svg>
);

export default PricingImage;
